<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<!-- Управление мелкими посылками/маркировкой -->
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- Вкладки -->
						<div class="navBox f-bct">
							<p class="a">Пакетный импорт номеров логистических накладных</p>
							<p @click="back()">Вернуться на предыдущую страницу</p>
						</div>
						<!-- Фильтр -->
						<div class="shaixuan f-ct">
							<div class="l f-ct">
								<div class="itm">
									<span style="width: auto;">Выбрать код</span>
									<el-select v-model="mtIdx" placeholder="Пожалуйста, выберите">
										<el-option
												v-for="item in mtList"
												:key="item.value"
												:label="item.label"
												:value="item.value">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
						<div class="nubtips">Введите номер экспресс-накладной. Для нескольких номеров используйте новую строку.</div>
						<div class="snBox">
							<el-input
									type="textarea"
									:rows="2"
									placeholder="Пожалуйста, введите содержание"
									v-model="textarea">
							</el-input>
						</div>
						<div class="btnBox f-ct" style="margin-top: 30px;">
							<div class="b2" @click="packageMiniBatchImport">Импортировать</div>
							<div class="b1" @click="back()">Назад</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { packageMiniBatchImport,
		memberCodeList} from "/src/api/api.js"
	import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
	export default {
		components: {
			'leftBox': () => import('@/components/leftBox.vue')
		},
		data(){
			return {
				textarea:'',
				// Маркировка
				mtList:[],
				mtIdx:0,
			}
		},
		mounted() {
			this.memberCodeList()
		},
		methods:{
			// Пакетный импорт мелких посылок
			async packageMiniBatchImport(){
				if(!this.mtList.length){
					this.Tips('Пожалуйста, сначала добавьте маркировку')
					this.link('/maitouList')
					return
				}
				var expressNumberList = []
				expressNumberList = this.textarea.split('\n')
				const res = await packageMiniBatchImport({
					expressNumberList,
					memberCodeId:this.mtIdx,
				})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.textarea = ''
				}else{this.Tips(res.msg)}
			},
			// Список маркировок
			async memberCodeList(){
				const res = await memberCodeList({})
				if(res.code==200){
					var mtList = []
					for(var i in res.rows){
						mtList.push({
							...res.rows[i],
							value:res.rows[i].id,
							label:res.rows[i].memberCode,
						})
					}
					this.mtList = mtList
					this.mtIdx = res.rows[0].id
				}else{this.Tips(res.msg)}
			},
		},
		computed:{
			...mapState('userMsg',['userInfo']),
		}
	}
</script>
<style lang="scss">
	body{
		// background: #f6f7fb;
	}
</style>
<style lang="scss" scoped>
	.pcon{
		padding: 0 74px;
		padding-bottom: 46px;
	}
	.banner{
		width: 100%;
		height: 413px;
		.el-image{
			width: 100%;
			height: 413px;
			border-radius: 18px;
		}
		.dian{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 16px;
			z-index: 2;
			div{
				margin: 0 3px;
				width: 8px;
				height: 8px;
				border-radius: 8px;
				background: #00000033;
				transition:0.3s;
			}
			.a{
				background: #fff;
				width: 14px;
				transition:0.3s;
			}
		}
	}
	.shaixuan{
		padding: 0 24px;
		padding-top: 24px;
		margin-bottom: 24px;
		padding-left: 0;
		.l{
			.itm{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
			}
			.itm1{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				border: 1px solid #DDDDDD;
				border-radius: 4px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
				::v-deep .el-input__inner{
					background: none;
					border: none;
					padding-left: 0;
				}
				.el-image{
					display: block;
					width: 16px;
					margin-left: 16px;
					margin-right: 12px;
				}
			}
		}
		.seachBtn{
			transform: translateX(-12px);
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				&:first-child{
					background: #38ABB0;
					border: 1px solid #38ABB0;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
	.delBag{
		width: 140px;
		height: 42px;
		border: 1px solid #DDDDDD;
		font-size: 16px;
		color: #666666;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		border-radius: 6px;
		background: #FF4D5A;
		border: 1px solid #FF4D5A;
		color: #fff;
		// margin-right: 12px;
		margin-top: 12px;
		margin-left: 1020px;
	}
	.pageCon{
		margin-top: 32px;
		justify-content: space-between;
		.pageConL{
			width: 530px;
		}
		.pageConR{
			width: calc(100% - 562px);
			.userNub{
				.itm{
					width: 382px;
					height: 158px;
					border-radius: 12px;
					background: #fff;
					padding-right: 46px;
					padding-left: 36px;
					.el-image{
						width: 80px;
					}
					.txt{
						width: calc(100% - 90px);
						margin-right: 10px;
						.t1{
							font-size: 42px;
							font-weight: bold;
						}
						.t2{
							font-size: 20px;
							color: #666666;
						}
					}
				}
			}
			.listBox{
				.tit{
					.tl{
						display: flex;
						align-items: center;
						.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
						p{
							font-size: 18px;
							padding-left: 10px;
						}
					}
					.tr{
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
						}
						p{
							font-size: 16px;
							color: #666666;
						}
					}
				}
				.zw{
					padding-top: 0;
					.el-image{
						margin-bottom: 0;
					}
				}
				.smallBox{
					width: 100%;
					// height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.smallList{
						margin-top: 16px;
						// height: 340px;
						// background: pink;
						// overflow: scroll;
						.itm{
							border: 1px solid #EFF1F6;
							border-radius: 8rpx;
							margin-bottom: 16px;
							.sn{
								height: 56px;
								border-bottom: 1px solid #EFF1F6;
								background: #EFF1F6;
								padding: 0 24px;
								.el-image{
									display: block;
									width: 20px;
									margin-right: 12px;
									// margin-left: 24px;
								}
								.t1{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.t3{
									.snTxt{
										font-size: 16px;
										color: #999999;
										span{
											color: #333;
										}
									}
									.bor{
										width: 1px;
										height: 16px;
										background: #D9D9D9;
										margin: 0 24px;
									}
									.man{
										font-size: 16px;
									}
								}
								.t2{
									width: 72px;
									height: 30px;
									background: #C7F3F5;
									font-size: 14px;
									color: #38ABB0;
									text-align: center;
									line-height: 30px;
									border-radius: 4px;
								}
							}
							.detail{
								padding: 16px 0;
								.msg{
									width: calc(100% - 105px);
									padding-left: 24px;
									// background: pink;
									.img{
										width: 66px;
										height: 66px;
										border-radius: 6px;
										margin-right: 16px;
									}
									.r{
										width: calc(100% - 82px);
										.cBox{
											margin-bottom: 10px;
											&:last-child{
												margin-bottom: 0;
											}
										}
										.nubitm{
											display: flex;
											align-items: center;
											// margin-right: 63px;
											width: 176px;
											.el-image{
												width: 20px;
												height: 20px;
												margin-right: 6px;
											}
											p{
												font-size: 16px;
											}
										}
									}
								}
								.bor{
									width: 1px;
									height: 50px;
									background: #D9D9D9;
								}
								.caozuo{
									width: 104px;
									// background: #00000033;
									p{
										text-align: center;font-size: 16px;
										cursor: pointer;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
										margin-top: 6px;
									}
									.t3{
										color: #38ABB0;
										margin-top: 6px;
									}
								}
							}
						}
					}
				}
				.mtBox{
					width: 382px;
					height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.maitouList{
						margin-top: 16px;
						height: 330px;
						// background: pink;
						overflow: scroll;
						padding-left: 3px;
						.mtItm{
							margin-bottom: 22px;
							.l{
								.nub{
									// width: 20px;
									height: 20px;
									background: #38ABB0;
									margin-right: 12px;
									color: #fff;
									border-radius: 20px;
									font-size: 13px;
									text-align: center;
									line-height: 19px;
									padding: 0 5px;
									padding-left: 6px;
								}
								.el-image{
									width: 45px;
								}
								p{
									font-size: 16px;
									padding-left: 6px;
								}
							}
							.r{
								display: flex;
								align-items: center;justify-content: flex-end;
								.bor{
									width: 1px;
									height: 16px;
									margin: 0 10px;
									background: #D9D9D9;
								}
								.btnItm{
									display: flex;
									align-items: center;
									.el-image{
										width: 14px;
										margin-right: 4px;
									}
									p{
										font-size: 14px;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
									}
								}
							}
						}
					}
					.tableImgList{
						margin-top: 16px;
						height: 340px;
						// background: pink;
						overflow: scroll;
						.el-image{
							width: 100%;
							height: 154px;
							margin-bottom: 16px;
							border-radius: 12px;
						}
					}
				}
			}
		}
	}
	.shaixuan{
		padding: 0 24px;
		padding-top: 24px;
		margin-bottom: 24px;
		padding-left: 0;
		.l{
			.itm{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
			}
			.itm1{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				border: 1px solid #DDDDDD;
				border-radius: 4px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
				::v-deep .el-input__inner{
					background: none;
					border: none;
					padding-left: 0;
				}
				.el-image{
					display: block;
					width: 16px;
					margin-left: 16px;
					margin-right: 12px;
				}
			}
		}
		.seachBtn{
			transform: translateX(-12px);
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				&:first-child{
					background: #38ABB0;
					border: 1px solid #38ABB0;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
	.rukuSel{
		.l{
			.el-image{
				width: 20px;
				margin-right: 12px;
			}
			span{
				font-size: 14px;
			}
		}
		.seachBtn{
			p{
				font-size: 14px;
				padding-right: 16px;
			}
			div{
				width: 128px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
	.navBox{
		border-bottom: 1px solid #EEEEEE;
		// padding: 0 10px;
		p{
			// padding-top: 24px;
			padding-bottom: 16px;
			// margin-right: 56px;
			font-size: 18px;
			cursor: pointer;
			color: #7D7D89;
			&::after{
				position: absolute;
				content: '';
				width: 0%;
				height: 4px;
				border-radius: 4px;
				background: #38ABB0;
				bottom: 0%;
				left: 50%;
				transform: translateX(-50%);
				transition:0.3s;
			}
		}
		.a{
			color: #38ABB0;
			font-weight: bold;
			&::after{
				width: 100%;
				transition:0.3s;
			}
		}
	}
	.smallListTit{
		margin-top: 24px;
		margin-bottom: 24px;
		.tl1{
			display: flex;
			align-items: center;
			.bor{
				width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;
			}
			p{
				font-size: 18px;
				padding-left: 24px;
				font-weight: bold;
			}
		}
		.tr1{
			.el-image{
				width: 20px;
				margin-left: 8px;
			}
			p{
				font-size: 16px;
				color: #38ABB0;
			}
		}
	}
	.bigBagMsg{
		margin-top: 24px;
		border-radius: 10px;
		border: 1px solid #EEEEEE;
		padding-top: 24px;
		padding-bottom: 36px;
		.tit{
			padding-bottom: 20px;
			padding-right: 18px;
			.tl1{
				display: flex;
				align-items: center;
				.bor{
					width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;
				}
				p{
					font-size: 18px;
					padding-left: 24px;
					font-weight: bold;
				}
			}
			.tr1{
				width: 72px;
				height: 30px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 28px;
				cursor: pointer;
				border-radius: 4px;
				background: #C7F3F5;
				border: 1px solid #C7F3F5;
				color: #38ABB0;
				margin-right: 12px;
			}
			.tr{
				display: flex;
				align-items: center;
				.el-image{
					width: 20px;
				}
				p{
					font-size: 16px;
					color: #666666;
				}
			}
		}
		.bagDetail{
			.bagimg{
				width: 572px;
				border-right: 1px solid #EBEEF5;
				padding-left: 24px;
				.el-image{
					width: 182px;
					height: 182px;
					border-radius: 6px;
					margin-right: 20px;
				}
				.bagimgR{
					width: calc(100% - 202px);
					.nubitm{
						display: flex;
						align-items: center;
						// margin-right: 63px;
						width: 164px;
						margin-bottom: 15px;
						.el-image{
							width: 20px;
							height: 20px;
							margin-right: 6px;
						}
						p{
							font-size: 16px;
						}
					}
					.anniu{
						width: 108px;
						height: 42px;
						border: 1px solid #DDDDDD;
						font-size: 16px;
						color: #666666;
						text-align: center;
						line-height: 38px;
						cursor: pointer;
						border-radius: 6px;
						background: #38ABB0;
						border: 1px solid #38ABB0;
						color: #fff;
						margin-right: 12px;
					}
				}
			}
			.bagCar{
				padding-left: 48px;
				width: calc(100% - 572px);
				// background: pink;
				padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 10px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
		.bagDetail1{
			margin: 0 28px;
			border-top: 1px solid #DDDDDD;
			padding-top: 28px;
			.bagCar1{
				// width: 50%;
				width: 495px;
				// padding-left: 48px;
				// width: calc(100% - 572px);
				// background: pink;
				// padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 12px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
	}
	.carStatusList{
		border: 1px solid #EEEEEE;
		border-radius: 10px;
		padding: 30px;
		.wlStatus{
			// width: 662px;
			margin: auto;
			background: #FFFFFF;
			border-radius: 0 0 16px 16px;
			// padding: 0 32px;
			// padding-top: 44px;
			padding-bottom: 2px;
			height: 480px;
			overflow: scroll;
			padding-left: 3px;
			.itm{
				border-left: 1px dashed #B8BAC1;
				margin-left: 5px;
				padding-bottom: 20px;
				&:first-child{
					margin-top: 0;
				}
				&:last-child{
					border-left: 2px dashed #fff;
				}
				.l{
					height: 12px;
					width: 12px;
					border-radius: 50%;
					background: #38ABB0;
					margin-right: 0px;
					transform: translateX(-6px);
				}
				.r{
					padding-left: 35px;
					transform: translateY(-4px);
					.t1{
						color: #2F3541;
						font-size: 16px;
						// margin-top: -2px;
						margin-top: 10px;
					}
					.t2{
						font-size: 14px;
						color: #9A9DA7;
						// margin-top: 10px;
					}
					.t3{
						color: #9A9DA7;
						font-size: 16px;
						// margin-top: -2px;
						margin-top: 10px;
					}
					.anniu{
						width: 176px;
						height: 72px;
						line-height: 72px;
						font-size: 24px;
						margin: 0;
						margin-top: 12px;
						letter-spacing: normal;
					}
					.red{
						background: #F26161;
					}
					.org{
						background: #E86F26;
					}
					.redT{
						color: #F26161;
					}
					.blueT{
						color: #3B6492;
					}
				}
			}
		}
	}
	.nubtips{
		margin: auto;
		color: #FF4D5A;
		font-size: 16px;
		margin-top: 20px;
	}
	.snBox{
		margin: auto;
		background: #F6F6F6;
		height: 468px;
		overflow: scroll;
		padding: 16px 20px;
		border-radius: 6px;
		margin-top: 16px;
		font-size: 14px;
		.el-textarea{
			height: 100%;
			// background: pink;
		}
		::v-deep .el-textarea__inner{
			padding: 0;
			height: 100%;
			background: none;
			margin: 0;
			padding: 0;
			border: none;
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
			margin-left: 14px;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
		}
	}
</style>